import React from "react";
const ALERT_KEY = "lpb-hide-alert-4252025";

/**
 * Alert Component
 * Renders an alert modal to give players timely updates about the site
 */
class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: localStorage.getItem(ALERT_KEY) ? false : true,
    };

    if (this.state.showModal) {
      // if modal is open, handle keydown
      document.addEventListener("keydown", this.handleKeydown);
    }
  }

  handleKeydown = (event) => {
    if (event.code === "Escape") {
      this.dismissModal();
    }
  };

  closeModal = () => {
    this.setState({ showModal: false });
    document.removeEventListener("keydown", this.handleKeydown);
  };

  dismissModal = () => {
    localStorage.setItem(ALERT_KEY, true);
    this.setState({ showModal: false });
    document.removeEventListener("keydown", this.handleKeydown);
  };

  render() {
    return this.state.showModal ? (
      <div>
        <div className="modal large-modal">
          <h2>Hello Bingo Friends!</h2>
          <h6>May 1st, 2025</h6>
          <p className="text-left">
            I wanted to provide you all with a little update on the status of <span className="notranslate">Let's Play Bingo</span>.
          </p>
          <p className="text-left">
            I apologize if you have emailed me or reached out and did not get a response. Over the course of the last 9 months I have had some massive life changes including a big cross country move (solo with two kiddos)! I am finally settling into my new life in the beautiful Pacific North West of America and finding my new normal. I am slowly making my way through my back log of emails and getting caught up. I won't be responding to support emails that were sent prior to mid-April because I
            assume you will have figured out your issue by now. However, I will be reading every email and if it requires action I will address it, I promise.
          </p>
          <p className="text-left">
            In more exciting news - I am planning a new edition of <span className="notranslate">Let's Play Bingo</span> and if you'd like to share some feedback to help guide development{" "}
            <a href="https://forms.gle/opHZbzcRszipzABcA" target="_blank">
              please fill out this survey
            </a>
            !
          </p>
          <p>Thanks for playing!</p>
          <p className="text-center no-text-wrap">
            <button aria-label="Close" className="primary-button margin-bottom-xlg" onClick={this.closeModal}>
              Close
            </button>
            <br />
            <button aria-label="Hide" className="cancel-button x-small-text" onClick={this.dismissModal}>
              Don't Show This Again
            </button>
          </p>
        </div>
        <div className="modal-backdrop"></div>
      </div>
    ) : null;
  }
}

export default Alert;
